
	import {
		ElMessage
	} from 'element-plus'

	export default {
		data() {
			return {
				clientWidth: document.documentElement.clientWidth,
				labelPosition: 'right',
				shotinputwidth: {
					width: '280px'
				},
				form: {
					mingcheng: '',
					xingbie: '',
					shouji: '',
					email: '',
					jueseid: '',
					jueseming: '',
					lianxiren: '',
					touxiang: '',
				},
				loading: false,
			}
		},
		beforeCreate() {
			this.PAGELANG = this.LANG.pages.OpProfile;
		},
		created() {
			window.addEventListener('resize', this.handleResize)
		},
		mounted() {
			let that = this;
			if (that.clientWidth <= 480) {
				that.labelPosition = 'top';
				that.shotinputwidth = {};
			} else {
				that.labelPosition = 'right';
				that.shotinputwidth = {
					width: '280px'
				};
			}
			
			this.refreshPageInfo();
		},
		methods: {
			handleResize() {
				this.clientWidth = document.documentElement.clientWidth;
			},
			refreshPageInfo() {
				if(this.loading) {
					ElMessage({
						message: this.LANG.system.xitongfanmang,
						type: "warning"
					})
					return;
				}
				this.loading = true;
				this.axios.get(this.actions.getopinfo).then((response) => {
					console.log(response);
					this.loading = false;
					let uinfo = response.data;
					this.form.mingcheng = uinfo.OpName;
					this.form.xingbie = uinfo.Gender;
					this.form.shouji = uinfo.OpMobile;
					this.form.email = uinfo.Email;
					this.form.jueseid = uinfo.RoleID;
					this.form.jueseming = uinfo.RoleName;
					this.form.touxiang = uinfo.HeadImage;
				});

			},
			onSubmit() {
				/*this.axios.get("/api/api.sample.js").then((response) => {
					if (response.status == 200)
						console.log(response.data);
				})*/
				if(this.loading) {
					ElMessage({
						message: this.LANG.system.xitongfanmang,
						type: "warning"
					})
					return;
				}
				this.loading = true;
				this.axios.post(this.actions.saveuserinfo, this.form).then((response) => {
					console.log(response);
					if (response.data.retinfo == 'ok') {
						ElMessage({
							message: this.LANG.system.chenggonggengxinshuju,
							type: "success"
						});
					}
					else {
						ElMessage({
							message: this.LANG.system.gengxinshujucuowu,
							type: "error"
						});
					}
					this.loading = false;
				});
			},
			onCancel() {
				this.refreshPageInfo();
			}
		},
		watch: {
			clientWidth(val) {
				// 为了避免频繁触发resize函数导致页面卡顿，使用定时器
				if (!this.timerw) {
					// 一旦监听到的clientWidth值改变，就将其重新赋给data里的clientWidth
					this.clientWidth = val
					this.timerw = true
					let that = this
					setTimeout(function() {
						// 打印clientWidth变化的值
						if (that.clientWidth <= 480) {
							that.labelPosition = 'top';
							that.form.shotinputwidth = {};
						} else {
							that.labelPosition = 'right';
							that.form.shotinputwidth = {
								width: '280px'
							};
						}
						console.log(that.labelPosition + '-' + that.clientWidth)
						that.timerw = false
					}, 400)
				}
			},
		}
	}
